import { render, staticRenderFns } from "./ClaimDetails.vue?vue&type=template&id=78f3f3d0"
import script from "./ClaimDetails.vue?vue&type=script&lang=js"
export * from "./ClaimDetails.vue?vue&type=script&lang=js"
import style0 from "./ClaimDetails.vue?vue&type=style&index=0&id=78f3f3d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports